interface CarSpecPayload {
  spec?: {
    make?: string;
    model?: string;
    year?: number | string;
    trim?: string;
    drivetrain?: string;
    powertrain?: {
      total_power_hp?: number;
      total_power_kw?: number;
      total_torque_nm?: number;
      engine_displacement_l?: number;
      engine_layout?: string;
    };
    performance?: {
      acceleration_0_100_kph_s?: number;
      top_speed_kph?: number;
    };
    dimensions?: {
      curb_weight_kg?: number;
      weight_distribution_front_pct?: number;
      wheelbase_mm?: number;
    };
    tires?: {
      front?: string;
      rear?: string;
    };
    brakes?: {
      front?: string;
      rear?: string;
    };
    suspension?: {
      front?: string;
      rear?: string;
      damper?: string;
    };
  };
}

export function CarSpecPanel({ payload }: { payload: unknown }) {
  const spec = (payload as CarSpecPayload)?.spec;
  if (!spec) {
    return <p className="muted small">没有车型规格数据。</p>;
  }
  const name = `${spec.year ?? ""} ${spec.make ?? ""} ${spec.model ?? ""}${
    spec.trim ? ` · ${spec.trim}` : ""
  }`.trim();
  return (
    <div className="carspec-block">
      <h4 className="carspec-name">{name || "未命名车型"}</h4>
      <div className="carspec-grid">
        {spec.drivetrain ? (
          <CarSpecRow label="驱动" value={spec.drivetrain} />
        ) : null}
        {spec.powertrain?.total_power_hp ? (
          <CarSpecRow
            label="动力"
            value={`${spec.powertrain.total_power_hp} hp${
              spec.powertrain.total_torque_nm
                ? ` · ${spec.powertrain.total_torque_nm} Nm`
                : ""
            }`}
          />
        ) : null}
        {spec.powertrain?.engine_layout ? (
          <CarSpecRow
            label="发动机"
            value={`${spec.powertrain.engine_layout}${
              spec.powertrain.engine_displacement_l
                ? ` · ${spec.powertrain.engine_displacement_l}L`
                : ""
            }`}
          />
        ) : null}
        {spec.performance?.acceleration_0_100_kph_s ? (
          <CarSpecRow
            label="0-100"
            value={`${spec.performance.acceleration_0_100_kph_s}s`}
          />
        ) : null}
        {spec.performance?.top_speed_kph ? (
          <CarSpecRow label="极速" value={`${spec.performance.top_speed_kph} km/h`} />
        ) : null}
        {spec.dimensions?.curb_weight_kg ? (
          <CarSpecRow
            label="重量"
            value={`${spec.dimensions.curb_weight_kg} kg${
              spec.dimensions.weight_distribution_front_pct
                ? ` · 前 ${spec.dimensions.weight_distribution_front_pct}%`
                : ""
            }`}
          />
        ) : null}
        {spec.dimensions?.wheelbase_mm ? (
          <CarSpecRow label="轴距" value={`${spec.dimensions.wheelbase_mm} mm`} />
        ) : null}
        {spec.tires?.front || spec.tires?.rear ? (
          <CarSpecRow
            label="原厂轮胎"
            value={`${spec.tires.front ?? "—"} / ${spec.tires.rear ?? "—"}`}
          />
        ) : null}
        {spec.brakes?.front || spec.brakes?.rear ? (
          <CarSpecRow
            label="刹车"
            value={`${spec.brakes.front ?? "—"} / ${spec.brakes.rear ?? "—"}`}
          />
        ) : null}
        {spec.suspension?.front || spec.suspension?.damper ? (
          <CarSpecRow
            label="悬挂"
            value={`${spec.suspension.front ?? "—"} · ${spec.suspension.damper ?? "—"}`}
          />
        ) : null}
      </div>
    </div>
  );
}

function CarSpecRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="carspec-row">
      <span className="carspec-label">{label}</span>
      <span className="carspec-value">{value}</span>
    </div>
  );
}
